import { EventBus } from '../../helpers';

type AddOnsEvents = {
  addOnAdded: [addOnId: string, option?: string];
  addOnRemoved: [addOnId: string];
};

class AddOnsEventBus extends EventBus<AddOnsEvents> {}

export const addOnsEventBus = new AddOnsEventBus();
